module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_8023.8a6a5f0b.png";